import React, { useState, useEffect } from "react"
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col"
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import DatePicker from "react-datepicker";
import $ from 'jquery'
import "react-datepicker/dist/react-datepicker.css";


const InputField = ({startDate, setDateValues, setStartDate,fieldClass, labelClass, type, name, value, required, placeholder, handlechange, pattern, label, grpmd, step, inputlabel, defaultValue }) => {

  let d = new Date();
  let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  const [date_value, onChange] = useState(new Date(utc + (3600000*"+1")));

  if(type == 'datetime' && date_value) {
  var month = (date_value.getMonth() + 1).toString()
  var date;
  var day = date_value.getDate();
  if (month.length === 1)
    month = '0' + month;
  if (day.length === 1)
    day = '0' + day;
    date = `${date_value.getFullYear()}-${month}-${day}`;
    setDateValues(date_value)
  }

  useEffect(() => {
  //$("#validationconfirm_payment").prop("readonly",true);
  var input = document.getElementById('validationtelephone');
  if(input) {
    input.onkeydown = function(e) {
        var k = e.which;
        /* numeric inputs can come from the keypad or the numeric row at the top */
        if ( (k < 48 || k > 57) && (k < 96 || k > 105) && (k != 8)) {
            e.preventDefault();
            return false;
        }
    };
  }

}, []);

return (

  <Form.Group as={Col} md={grpmd} className={`${type} ${step}`} controlId={"validation" + name}>
    <div className="custom-float">
    { label
      ? <p className="label"><Form.Label className="form-label">{label}{required ? '*' : ''}</Form.Label></p>
      : ''
    }
    {type === 'datetime' ?
    <>
    <input type="hidden" name="valuation_book_date" value={date} />
    <Calendar
       onChange={onChange}
        value={date_value}
        minDate={new Date()}
    />
    </> : type === 'date_time' ?
    <DatePicker
                selected={startDate}
                onChange={date => setStartDate(date)}
                showTimeSelect
                minDate={new Date()}
                placeholderText={placeholder}
                dateFormat="MMMM d, yyyy h:mm aa"
                className={fieldClass}
                required={required}
                autocomplete="off"
                name={name}
                autoComplete={'' + Math.random()}
                // onChange={handlechange}
                value={startDate}

              />
:
    <Form.Control
          className={fieldClass}
          required={required}
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={handlechange}
          pattern={pattern}
          autocomplete="off"
          defaultValue={defaultValue || ``}
        /> }

    </div>
  </Form.Group>
)
}

export default InputField;
